import { render, staticRenderFns } from "./CustomTextArea.vue?vue&type=template&id=5d1d7dbf"
import script from "./CustomTextArea.vue?vue&type=script&lang=js"
export * from "./CustomTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports